<template>
    <div class="modal fade" id="div-delete-passkey-result" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog" v-if="this.params.result">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">{{$t('MSG_TRS_NAF_0220')}}</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="clickCloseAfterSuccessfully()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center pt-0">
                    <img src="@/assets/img/register-passkey-successfully.png" width="56px"/>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-6 w-100">
                            <button type="button" class="btn btn-sm btn-primary w-100" @click="clickCloseAfterSuccessfully()">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import ServiceUtils from '@/common/utils/ServiceUtils';

    export default {
        name: "DeletePasskeyResult",
        data() {
            return {
                params: {
                    result: true,
                }
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_DELETE_PASSKEY_RESULT, (params) => {
                    $('#div-delete-passkey-result').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-delete-passkey-result").modal("show");
                });
            },
            async clickCloseAfterSuccessfully() {
                await ServiceUtils.waitModalFullyHidden($("#div-delete-passkey-result"));
                this.$modal.reloadRegisteredPasskeys();
            },
        }
    }
</script>

<style scoped>
    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }
</style>
